import React, { useState, useRef, useEffect, useCallback } from 'react';
import '../styles/dropItems.css';
import BLK1 from '../assets/images/drops/legend-dri-fit/BEGIN-BLK_1.png';
import BLK2 from '../assets/images/drops/legend-dri-fit/Back-BLK_2.jpg';
import BLK3 from '../assets/images/drops/legend-dri-fit/Front-Fit-BEGIN-BLK_3.jpg';
import BLK4 from '../assets/images/drops/legend-dri-fit/Back-Fit-BLK_4.jpg';
import BLK5 from '../assets/images/drops/legend-dri-fit/Side-Fit-BLK_5.jpg';
import ROY1 from '../assets/images/drops/legend-dri-fit/BEGIN-ROY_1.png';
import ROY2 from '../assets/images/drops/legend-dri-fit/Back-ROY_2.jpg';
import ROY3 from '../assets/images/drops/legend-dri-fit/Front-Fit-BEGIN-ROY_3.jpg';
import ROY4 from '../assets/images/drops/legend-dri-fit/Back-Fit-ROY_4.jpg';
import ROY5 from '../assets/images/drops/legend-dri-fit/Side-Fit-ROY_5.jpg';
import dropdownArrow from '../assets/icons/dropdown-arrow-white.svg';
import CloseIcon from '../assets/x.svg';

const DropItems = () => {
  const [modalImages, setModalImages] = useState([]);
  const [modalIndex, setModalIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalClosing, setModalClosing] = useState(false);
  const [selectedSizes, setSelectedSizes] = useState({});
  const [openDropdown, setOpenDropdown] = useState(null);
  const [sizeErrors, setSizeErrors] = useState({});
  const dropdownRefs = useRef({});
  const touchStartX = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (openDropdown !== null) {
        const ref = dropdownRefs.current[openDropdown];
        if (ref && !ref.contains(e.target)) {
          setOpenDropdown(null);
        }
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [openDropdown]);

  const openModal = (images, index = 0) => {
    if (!images || images.length === 0) return;
    setModalImages(images);
    setModalIndex(index);
    setModalClosing(false);
    setIsModalOpen(true);
  };

  const closeModal = useCallback(() => {
    setModalClosing(true);
    setTimeout(() => {
      setIsModalOpen(false);
      setModalClosing(false);
    }, 250);
  }, []);

  const nextImage = useCallback(() => {
    setModalIndex((prev) => (prev + 1) % modalImages.length);
  }, [modalImages.length]);

  const prevImage = useCallback(() => {
    setModalIndex((prev) => (prev - 1 + modalImages.length) % modalImages.length);
  }, [modalImages.length]);

  // Keyboard navigation
  useEffect(() => {
    if (!isModalOpen) return;
    const handleKey = (e) => {
      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowRight') nextImage();
      if (e.key === 'ArrowLeft') prevImage();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [isModalOpen, closeModal, nextImage, prevImage]);

  // Lock body scroll when modal is open
  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isModalOpen]);

  // Touch swipe handlers
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) nextImage();
      else prevImage();
    }
    touchStartX.current = null;
  };

  const items = [
	{
	  name: 'Thunder Orange / Royal Blue',
	  description: 'Royal Blue Nike Dri-Fit Legend with Begin Strength in Thunder Orange.',
	  price: '$34.99',
	  images: [ROY1, ROY2, ROY3, ROY4, ROY5],
	  links: {
		Small: 'https://pay.beginthework.com/b/9B6bJ16hj4u7bmWgLo2Nq0h',
		Medium: 'https://pay.beginthework.com/b/aFafZhdJL6CffDc0Mq2Nq0i',
		Large: 'https://pay.beginthework.com/b/eVq8wP8pr3q31Mm7aO2Nq0j',
		XLarge: 'https://pay.beginthework.com/b/4gMeVdcFH4u72Qq66K2Nq0k',
	  }
	},
	{
	  name: 'Silver / Black',
	  description: 'Black Nike Dri-Fit Legend with Begin Strength in Silver.',
	  price: '$34.99',
	  images: [BLK1, BLK2, BLK3, BLK4, BLK5],
	  links: {
		Small: 'https://pay.beginthework.com/b/5kQ28r357bWz62C52G2Nq0l',
		Medium: 'https://pay.beginthework.com/b/7sY8wPcFH1hVaiSeDg2Nq0m',
		Large: 'https://pay.beginthework.com/b/3cI7sL3575ybez8an02Nq0n',
		XLarge: 'https://pay.beginthework.com/b/eVq6oH8pre4H0IifHk2Nq0o',
	  }
	},
	{
	  name: 'Coming Soon',
	  description: 'Next Drop is coming soon!',
	  price: '',
	  images: [],
	  links: {
		
	  }
	},
  ];

  return (
	<>
<section className="drop-items" id="gear">
	  <div className="item-header">
		<h2 className="item-title">
		  Current <span style={{ color: 'red' }}>Drops</span>
		</h2>
		<p className="item-description">
		  Limited-Time Pre-Order: Pick your size and order by August 15th, 2025 to guarantee your gear.
		</p>
	  </div>
	
	  <div className="item-container">
		<div className="item-scroll">
		  {items.map((item, index) => (
			<div key={index} className="item-block">
			  <div
				className="item-card"
				style={{ backgroundImage: `url(${item.images[0]})` }}
				onClick={() => openModal(item.images)}
			  >
				<div className="item-overlay">
				  <div className="item-info">
					<h3 className="item-name">{item.name}</h3>
					<p className="item-description">{item.description}</p>
					<p className="item-price"><strong>{item.price}</strong></p>
				  </div>
				</div>
			  </div>
	
		  <div className="item-sizes">
			<div
			  className="size-dropdown-wrapper"
			  ref={(el) => (dropdownRefs.current[index] = el)}
			>
			  <button
				className={`size-dropdown-trigger ${sizeErrors[index] ? 'error' : ''}`}
				onClick={(e) => {
				  e.stopPropagation();
				  setSizeErrors(prev => ({ ...prev, [index]: false }));
				  setOpenDropdown(openDropdown === index ? null : index);
				}}
			  >
				<span>{selectedSizes[index] || 'Pick Size'}</span>
				<img
				  src={dropdownArrow}
				  alt="dropdown arrow"
				  className={`dropdown-icon ${openDropdown === index ? 'open' : ''}`}
				/>
			  </button>

			  {openDropdown === index && Object.keys(item.links).length > 0 && (() => {
				const triggerEl = dropdownRefs.current[index]?.querySelector('.size-dropdown-trigger');
				const rect = triggerEl?.getBoundingClientRect();
				const menuStyle = rect ? {
				  position: 'fixed',
				  top: `${rect.bottom}px`,
				  left: `${rect.left}px`,
				  width: `${rect.width}px`,
				} : {};
				return (
				  <div className="size-dropdown-menu" style={menuStyle}>
					{Object.keys(item.links).map((size) => (
					  <div
						key={size}
						className={`size-dropdown-item ${selectedSizes[index] === size ? 'selected' : ''}`}
						onClick={(e) => {
						  e.stopPropagation();
						  setSelectedSizes(prev => ({ ...prev, [index]: size }));
						  setSizeErrors(prev => ({ ...prev, [index]: false }));
						  setOpenDropdown(null);
						}}
					  >
						{size}
					  </div>
					))}
				  </div>
				);
			  })()}
			</div>
	
			<a
			  className={`buy-button ${!selectedSizes[index] ? 'disabled' : ''}`}
			  href={selectedSizes[index] ? item.links[selectedSizes[index]] : '#'}
			  target="_blank"
			  rel="noopener noreferrer"
			  onClick={(e) => {
				e.stopPropagation();
				if (!selectedSizes[index]) {
				  e.preventDefault();
				  setSizeErrors(prev => ({ ...prev, [index]: true }));
				  setOpenDropdown(null);
				}
			  }}
			>
			  Pre-Order
			</a>
			{sizeErrors[index] && (
			  <div className="size-error-message">Please pick a size first.</div>
			)}
		  </div>
			</div>
		  ))}
		</div>
	  </div>
	</section>

	  {isModalOpen && (
		<div
		  className={`image-modal ${modalClosing ? 'closing' : ''}`}
		  onClick={closeModal}
		>
		  {/* Close button */}
		  <button className="modal-close" onClick={closeModal}>
			<img src={CloseIcon} alt="Close" className="modal-close-icon" />
		  </button>

		  {/* Image counter */}
		  {modalImages.length > 1 && (
			<div className="modal-counter">
			  {modalIndex + 1} / {modalImages.length}
			</div>
		  )}

		  {/* Previous arrow */}
		  {modalImages.length > 1 && (
			<button
			  className="modal-arrow modal-arrow-left"
			  onClick={(e) => { e.stopPropagation(); prevImage(); }}
			>
			  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
				<polyline points="15 18 9 12 15 6" />
			  </svg>
			</button>
		  )}

		  {/* Main image area */}
		  <div
			className="modal-content"
			onClick={(e) => e.stopPropagation()}
			onTouchStart={handleTouchStart}
			onTouchEnd={handleTouchEnd}
		  >
			<img
			  key={modalIndex}
			  src={modalImages[modalIndex]}
			  alt={`Product view ${modalIndex + 1}`}
			  className="modal-main-image"
			  draggable={false}
			/>
		  </div>

		  {/* Next arrow */}
		  {modalImages.length > 1 && (
			<button
			  className="modal-arrow modal-arrow-right"
			  onClick={(e) => { e.stopPropagation(); nextImage(); }}
			>
			  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
				<polyline points="9 18 15 12 9 6" />
			  </svg>
			</button>
		  )}

		  {/* Thumbnail strip */}
		  {modalImages.length > 1 && (
			<div className="modal-thumbnails" onClick={(e) => e.stopPropagation()}>
			  {modalImages.map((img, i) => (
				<button
				  key={i}
				  className={`modal-thumb ${i === modalIndex ? 'active' : ''}`}
				  onClick={() => setModalIndex(i)}
				>
				  <img src={img} alt={`Thumbnail ${i + 1}`} draggable={false} />
				</button>
			  ))}
			</div>
		  )}
		</div>
	  )}
	</>
  );
};

export default DropItems;